// constants.ts
// All constant values used across the application

export const CHART_COLORS = {
    sent: "#6366F1",
    delivered: "#10B981",
    opened: "#F59E0B",
    unsubscribed: "#EF4444",
};

// Notification source types for filtering
export const NOTIFICATION_SOURCES = {
    all: 'All Notifications',
    transactional: 'Automatic (Transactional)',
    campaign: 'Campaign (Batch)',
} as const;

export type NotificationSource = keyof typeof NOTIFICATION_SOURCES;
